const FIELD_MAP = {
  patientName: 'patientName',
  patientBirthDate: 'patientBirthDate',
  patientPhone: 'patientPhone',
  healthInsuranceName: 'healthInsuranceName',
  // Kostenträgerkennung (IK) aus der Muster-4-Kopfzeile — Pflichtangabe für
  // die Kassenabrechnung, siehe krankenfahrten_tarife_konzept.md §11.3.
  healthInsuranceIk: 'healthInsuranceIk',
  insuranceNumber: 'insuranceNumber',
  insuranceStatus: 'insuranceStatus',
  practiceNumber: 'practiceNumber',
  physicianNumber: 'physicianNumber',
  // Anschrift des Versicherten (DMRZ-Felder 6-11) — steht im Versichertenblock
  // auf Muster 4 und ist nicht die Abholadresse.
  patientStreet: 'patientStreet',
  patientHouseNumber: 'patientHouseNumber',
  patientZip: 'patientZip',
  patientCity: 'patientCity',
  patientAddressAddition: 'patientAddressAddition',
  prescriptionNumber: 'prescriptionNumber',
  prescriptionDate: 'prescriptionDate',
  approvalNumber: 'approvalNumber',
  approvalRequired: 'approvalRequired',
  approvalStatus: 'approvalStatus',
  approvalHint: 'approvalHint',
  personGroupStatus: 'personGroupStatus',
  personGroupHint: 'personGroupHint',
  personGroupSource: 'personGroupSource',
  matchedCustomerId: 'customerId',
  medicalTransportEligibilitySnapshot: 'medicalTransportEligibilitySnapshot',
  validFrom: 'validFrom',
  validUntil: 'validUntil',
  maxRides: 'maxRides',
  ridesPerWeek: 'ridesPerWeek',
  pickupAddress: 'pickupAddress',
  destinationAddress: 'destinationAddress',
  treatmentType: 'treatmentType',
  routeScope: 'routeScope',
  transportRequirementMode: 'transportRequirementMode',
  requiredCapabilities: 'requiredCapabilities',
  defaultVehicleType: 'defaultVehicleType',
  copaymentStatus: 'copaymentStatus',
  copaymentHint: 'copaymentHint',
  outboundTrip: 'outboundTrip',
  returnTrip: 'returnTrip',
  // Freitext aus Punkt 4 der Verordnung („Begründung/Sonstiges") — dort steht
  // z. B. die Diagnose oder ein Hinweis auf Wartezeit/Gemeinschaftsfahrt. Das
  // Formular hängt ihn als „OCR-Auszug" an die internen Notizen an.
  defaultNotes: 'defaultNotes',
};

/**
 * Ankreuzfelder von Muster 4. Sie werden getrennt behandelt, weil `false` eine
 * echte Aussage ist („nicht angekreuzt") und nicht wie ein leeres Feld
 * übersprungen werden darf — die Erkennung im Scan ist gegen den Rohtext
 * abgesichert und damit belastbarer als eine stehengebliebene Voreinstellung.
 */
const BOOLEAN_FIELDS = [
  'prescriptionMarkBvg',
  'prescriptionMarkAccident',
  'prescriptionMarkWorkAccident',
];

export const mapScanToFormState = (scanResult) => {
  const fields = scanResult?.fields || {};
  const patch = {};

  Object.entries(FIELD_MAP).forEach(([source, target]) => {
    const value = fields[source];
    if (value === undefined || value === null || value === '') return;
    patch[target] = value;
  });

  BOOLEAN_FIELDS.forEach(field => {
    if (typeof fields[field] === 'boolean') patch[field] = fields[field];
  });

  patch.prescriptionScanId = scanResult?.scanId || null;
  patch.prescriptionScanRef = scanResult?.storagePath || null;
  patch.prescriptionScanConfidence = scanResult?.confidence || {};

  if (scanResult?.status === 'needs_review') {
    patch.documentStatus = 'incomplete';
  }

  return patch;
};
